import wpAjax from '../helpers/axios';

async function sendErrorEmail(prizeCode, email) {
	if (prizeCode == 'lose') return false;

	const { data } = await wpAjax.post('', {
		prizeCode,
		email,
		action: 'ajax_send_error_email',
	});

	return data;
}

export default sendErrorEmail;
